import React from 'react';
import { Card } from '../../components/ui/Card';
export function Checkout() {
  return <div className="space-y-4 max-w-3xl" data-id="element-1696" data-mp="ktmda2c1346x">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1697" data-mp="kuxj07p1am0o">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-1698" data-mp="tu141h7rhbht">
          Checkout
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-1699" data-mp="18ix9d6ifoaeq">
          Complete your purchase to begin your courses.
        </p>
      </div>
      <div className="rounded-xl p-6 space-y-4" style={{
      backgroundColor: '#FDF6E3'
    }} data-id="element-1700" data-mp="13kncmrh291r0">
        <p className="text-sm text-slate-600" data-id="element-1701" data-mp="1hj3iyhb0gq8m">Your cart is now empty</p>

        {/* Contact Information */}
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1702" data-mp="1clbqnm6gf23w">
          <div style={{
          backgroundColor: '#4A2D8F'
        }} className="px-4 py-2" data-id="element-1703" data-mp="3jc1jz0exyp4n">
            <h2 className="text-white text-sm font-semibold text-center" data-id="element-1704" data-mp="3edzvu12nrzmb">
              Contact Information
            </h2>
          </div>
          <div className="p-0" data-id="element-1705" data-mp="1fsbqbs3popqw">
            <table className="w-full text-sm" data-id="element-1706" data-mp="1ftms5mdljnfd">
              <tbody className="divide-y divide-slate-200" data-id="element-1707" data-mp="1kshn1mou92fu">
                {[{
                label: 'First Name :',
                value: 'Dana'
              }, {
                label: 'Last Name :',
                value: 'Kichen'
              }, {
                label: 'Company :',
                value: ''
              }, {
                label: 'Phone :',
                value: '4803910222'
              }, {
                label: 'Fax :',
                value: ''
              }, {
                label: 'Website :',
                value: ''
              }].map(row => <tr key={row.label} className="border-b border-slate-200" data-id="element-1708" data-mp="62jtq6z00z61">
                    <td className="px-3 py-1.5 text-slate-600 w-32 bg-slate-50" data-id="element-1709" data-mp="64wip436c9sl">
                      {row.label}
                    </td>
                    <td className="px-3 py-1.5" data-id="element-1710" data-mp="g2apebzapk7p">
                      <input type="text" defaultValue={row.value} className="w-full border border-slate-300 rounded px-2 py-0.5 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1711" data-mp="fywm91it56z7" />
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Billing Address */}
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1712" data-mp="ttpaqpgodxhx">
          <div style={{
          backgroundColor: '#4A2D8F'
        }} className="px-4 py-2" data-id="element-1713" data-mp="17rxd5cwhdr0h">
            <h2 className="text-white text-sm font-semibold text-center" data-id="element-1714" data-mp="13set0jchhjyp">
              Billing Address
            </h2>
          </div>
          <div className="p-0" data-id="element-1715" data-mp="1mdb471mce89f">
            <table className="w-full text-sm" data-id="element-1716" data-mp="1reh0taj4ifo8">
              <tbody className="divide-y divide-slate-200" data-id="element-1717" data-mp="1rc4lz68nwlfe">
                {[{
                label: 'Address :',
                value: '14793 N. 90th Place'
              }, {
                label: 'City :',
                value: 'Scottsdale'
              }, {
                label: 'State :',
                value: 'AZ'
              }, {
                label: 'Zip/Postal Code :',
                value: '85260'
              }].map(row => <tr key={row.label} className="border-b border-slate-200" data-id="element-1718" data-mp="yngx70opfdx3">
                    <td className="px-3 py-1.5 text-slate-600 w-36 bg-slate-50" data-id="element-1719" data-mp="kqagrcrgdrb1">
                      {row.label}
                    </td>
                    <td className="px-3 py-1.5" data-id="element-1720" data-mp="1s29s1uz0c99t">
                      <input type="text" defaultValue={row.value} className="w-full border border-slate-300 rounded px-2 py-0.5 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1721" data-mp="1s0ztl4o8sz2n" />
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>

        {/* Update button */}
        <div data-id="element-1722" data-mp="14coy6h1bfrlr">
          <button className="px-4 py-1.5 text-white text-sm font-bold rounded" style={{
          backgroundColor: '#2E7D32'
        }} data-id="element-1723" data-mp="14c75fudv3vil">
            Update
          </button>
        </div>

        {/* Credit Card Section */}
        <div className="space-y-3 text-sm" data-id="element-1724" data-mp="ved8qic6qzuw">
          <div className="flex items-end gap-4 flex-wrap" data-id="element-1725" data-mp="2upebb7h44dix">
            <div data-id="element-1726" data-mp="2pq1scxtd3qlm">
              <label className="block text-slate-700 mb-1" data-id="element-1727" data-mp="2ppi99drz6w60">
                Credit Card Number
              </label>
              <input type="text" className="border border-slate-300 rounded px-2 py-1 text-sm w-44 focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1728" data-mp="2xacaupzbq1pr" />
            </div>
            <div data-id="element-1729" data-mp="370oyws6ckd0n">
              <label className="block text-slate-700 mb-1" data-id="element-1730" data-mp="3705m1pvk0eth">Exp.</label>
              <div className="flex gap-1" data-id="element-1731" data-mp="3bx5j5bafe78g">
                <select className="border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none" data-id="element-1732" data-mp="3c09tyriec183">
                  {['Month', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map(m => <option key={m} data-id="element-1733" data-mp="7k8qb1khri27">{m}</option>)}
                </select>
                <select className="border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none" data-id="element-1734" data-mp="7m3cej7i1g7v">
                  {['Year', '2025', '2026', '2027', '2028', '2029', '2030'].map(y => <option key={y} data-id="element-1735" data-mp="2dlb2guq95d03">{y}</option>)}
                </select>
              </div>
            </div>
            <div data-id="element-1736" data-mp="28mzt0l3vd4ie">
              <label className="block text-slate-700 mb-1" data-id="element-1737" data-mp="28kdkoj95mkz4">CCV</label>
              <div className="flex items-center gap-1" data-id="element-1738" data-mp="1kxp2dwg8gqhz">
                <input type="text" className="border border-slate-300 rounded px-2 py-1 text-sm w-16 focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1739" data-mp="1gvkb34d9c5yi" />
                <div className="w-5 h-5 rounded-full bg-blue-500 text-white text-xs flex items-center justify-center font-bold cursor-help" title="The 3-digit security code on the back of your card" data-id="element-1740" data-mp="1pvgr6hlkzwhy">
                  ?
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-4 flex-wrap" data-id="element-1741" data-mp="38tdet4dssjt9">
            <div className="flex-1 min-w-32" data-id="element-1742" data-mp="3dlwrlz4nvax0">
              <label className="block text-slate-700 mb-1" data-id="element-1743" data-mp="3dmoac9d5te5v">First Name</label>
              <input type="text" defaultValue="Dana" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1744" data-mp="2zv9qy1fcbaya" />
            </div>
            <div className="flex-1 min-w-32" data-id="element-1745" data-mp="ev2gqgtqi3u">
              <label className="block text-slate-700 mb-1" data-id="element-1746" data-mp="djz2rrajcd9">Last Name</label>
              <input type="text" defaultValue="Kichen" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1747" data-mp="3il9ak8sevxub" />
            </div>
          </div>

          <div data-id="element-1748" data-mp="2c44c9pl4yopk">
            <label className="block text-slate-700 mb-1" data-id="element-1749" data-mp="2c4xdkb1bsm0b">Email</label>
            <input type="email" defaultValue="reggieborris@yahoo.com" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1750" data-mp="2c21fmmph9xbv" />
          </div>

          <div className="flex gap-4 flex-wrap" data-id="element-1751" data-mp="2tub2luw8kd2m">
            <div className="flex-1 min-w-40" data-id="element-1752" data-mp="2ouy76lratxof">
              <label className="block text-slate-700 mb-1" data-id="element-1753" data-mp="2ow9bcmonp7g2">Address</label>
              <input type="text" defaultValue="14793 N. 90th Place" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1754" data-mp="3miq8nrxe3l1t" />
            </div>
            <div className="flex-1 min-w-28" data-id="element-1755" data-mp="37ttz1qfopzz3">
              <label className="block text-slate-700 mb-1" data-id="element-1756" data-mp="37t11ng2m8mtm">City</label>
              <input type="text" defaultValue="Scottsdale" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1757" data-mp="93ttcado8zl8" />
            </div>
          </div>

          <div className="flex gap-4 flex-wrap" data-id="element-1758" data-mp="gmtbkcpecl30">
            <div className="w-16" data-id="element-1759" data-mp="gnl7xpqtimuc">
              <label className="block text-slate-700 mb-1" data-id="element-1760" data-mp="lm5y0wccvq52">State</label>
              <input type="text" defaultValue="AZ" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1761" data-mp="lkutgub36ecw" />
            </div>
            <div className="w-24" data-id="element-1762" data-mp="zlfgy3ry4ycq">
              <label className="block text-slate-700 mb-1" data-id="element-1763" data-mp="zke35rjjpxrb">Zip Code</label>
              <input type="text" defaultValue="85260" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1764" data-mp="14doz2xmtku4g" />
            </div>
            <div className="w-24" data-id="element-1765" data-mp="1j9xwdtn5gxe8">
              <label className="block text-slate-700 mb-1" data-id="element-1766" data-mp="1j94vh9avh240">Country</label>
              <input type="text" defaultValue="US" className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1767" data-mp="2e9gx828m0baw" />
            </div>
          </div>

          <div className="flex gap-6 items-start" data-id="element-1768" data-mp="2n7sng35kd72t">
            <div className="flex-1" data-id="element-1769" data-mp="2s0vkwmdgp0oa">
              <label className="block text-slate-700 mb-1" data-id="element-1770" data-mp="2s1wusniqrh4f">
                Customer Notes
              </label>
              <textarea rows={4} className="w-full border border-slate-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-purple-400" data-id="element-1771" data-mp="2x21boenkadv6" />
            </div>
            <div className="text-center pt-4" data-id="element-1772" data-mp="3az7ta5wju6it">
              <p className="text-xs text-slate-600 mb-1" data-id="element-1773" data-mp="3ayy1ccry1pah">
                Credit Card Processing
              </p>
              <div className="w-16 h-16 border border-slate-300 rounded flex items-center justify-center bg-slate-50" data-id="element-1774" data-mp="1bo6r3hvjauvb">
                <span className="text-xs text-slate-400 text-center leading-tight" data-id="element-1775" data-mp="1gn9ruq4heexh">
                  Authorize.Net
                </span>
              </div>
              <button className="mt-1 text-xs text-blue-600 hover:underline" data-id="element-1776" data-mp="14afmfadxzwbv">
                Credit Card Processing
              </button>
            </div>
          </div>
        </div>

        {/* Buy button */}
        <div className="flex items-center gap-3" data-id="element-1777" data-mp="ueuopofwpi7x">
          <button className="px-4 py-1.5 text-white text-sm font-bold rounded" style={{
          backgroundColor: '#2E7D32'
        }} data-id="element-1778" data-mp="1s1bhqhhlx9nv">
            Buy
          </button>
          <span className="text-sm font-medium" style={{
          color: '#CC0000'
        }} data-id="element-1779" data-mp="1i1kn8ft1quns">
            Please click BUY button only ONCE to avoid a duplicate order
          </span>
        </div>
      </div>
    </div>;
}